import React, { useCallback, useEffect } from 'react';

interface ViewportGridProps {
	/** Số cột */
	numRows: number;
	/** Số hàng */
	numCols: number;
	/** Loại bố cục */
	layoutType?: string;
	/** Mảng các React Component để render trong lưới */
	children: React.ReactNode[];
	/** Có bật chế độ responsive cho viewport grid không */
	isResponsiveViewportGrid?: boolean;
	/** Tỷ lệ kích thước ảnh, ví dụ "width/height" */
	ratio?: string;
}

import { useDicomPrint } from '@ui/contextProviders';

function ViewportGrid({
	// numRows, numCols, layoutType,
	children,
	isResponsiveViewportGrid,
}: ViewportGridProps) {
	const { state: dicomPrintState } = useDicomPrint();

	const ratio = dicomPrintState.imagePixelSizeFromFilm
		? `${dicomPrintState.imagePixelSizeFromFilm.widthPx}/${dicomPrintState.imagePixelSizeFromFilm.heightPx}`
		: undefined;
	const updateContainerSize = useCallback((isResponsiveViewportGrid: boolean, ratio: string) => {
		const viewportGridContainer = document.getElementsByClassName('viewport-grid-container')[0] as HTMLElement;
		if (!viewportGridContainer) {
			return;
		}
		// reset viewport grid container size to origin
		if (!isResponsiveViewportGrid) {
			viewportGridContainer.style.width = '100%';
			viewportGridContainer.style.height = '100%';
			viewportGridContainer.style.margin = 'auto';
			viewportGridContainer.style.position = '';
			return;
		}
		const [wRatio, hRatio] = ratio.split('/').map(Number);

		const maxW = viewportGridContainer.parentElement?.clientWidth ?? window.innerWidth;
		const maxH = viewportGridContainer.parentElement?.clientHeight ?? window.innerHeight;

		const targetRatio = wRatio / hRatio;
		const containerRatio = maxW / maxH;

		let newW, newH;

		if (containerRatio > targetRatio) {
			newH = maxH;
			newW = newH * targetRatio;
		} else {
			newW = maxW;
			newH = newW / targetRatio;
		}

		viewportGridContainer.style.width = `${newW}px`;
		viewportGridContainer.style.height = `${newH}px`;
		viewportGridContainer.style.margin = 'auto';
		viewportGridContainer.style.position = 'absolute';

		console.log('Resized →', newW, newH);
	}, []);

	useEffect(() => {
		if (!ratio || !isResponsiveViewportGrid) {
			return;
		}
		const updateSize = () => {
			updateContainerSize(isResponsiveViewportGrid, ratio);
		};
		window.addEventListener('resize', updateSize);
		return () => window.removeEventListener('resize', updateSize);
	}, [updateContainerSize, isResponsiveViewportGrid, ratio]);

	useEffect(() => {
		if (ratio) {
			updateContainerSize(isResponsiveViewportGrid, ratio);
		}
	}, [updateContainerSize, isResponsiveViewportGrid, ratio]);

	return (
		<>
			<div
				data-cy="viewport-grid"
				style={{
					position: 'relative',
					height: '100%',
					width: '100%',
				}}
			>
				{children}
			</div>
		</>
	);
}

export default ViewportGrid;
